import { FeatureKey } from 'vrlcm-gui-types';
import { AssetsApi } from '../ui-assets';

export class FeatureToggleApi {
  public static async isFeatureEnabled(featureKey: FeatureKey) {
    const featureToggle = await AssetsApi.getFeatureToggle();
    return featureToggle[featureKey];
  }
}
